class Chat {
  constructor (chatId) {
    this.chatId = chatId
    this.messageHandlers = []
  }

  onMessage (callback) {
    this.messageHandlers.push(callback)
  }

  message (message) {
    this.messageHandlers.forEach(callback => {
      callback(message)
    })
  }
}

export default Chat
